import { useCallback } from 'react'
import { ISidebarMenuItem } from './Menu'
import { match, matchPath } from 'react-router-dom'

const matchChildRecursive = (currentPath: string, items?: ISidebarMenuItem[]): boolean => {
  const found = items?.find(c => c.url && matchPath(currentPath, { path: c.url, exact: c.exact, strict: false }))
  if (found) {
    return true
  }
  const childFound = items?.find(c => c.children && matchChildRecursive(currentPath, c.children))
  return !!childFound
}

export const useIsRouteOrChildActiveFunc = (currentPath: string, items?: ISidebarMenuItem[]) => {
  return useCallback(
    (match: match) => {
      if (match) {
        return true
      }
      return matchChildRecursive(currentPath, items)
    },
    [items, currentPath]
  )
}
